import React from 'react';
import { observer } from 'mobx-react-lite';
import sonoraCommonStyles from './SonoraCommonStyles.scss';
import classnamesBind from 'classnames/bind';
import { ResultItemDetailValue } from 'owa-editor-sonora-types';
import { getIconForSonoraResultsDetailsItems } from '../utils/shared/getIconForSonoraResultsItems';
const classNames = classnamesBind.bind(sonoraCommonStyles);

export default observer(function SonoraResultsDetailsMenuItem({
    item,
    resultItemOnClickAction,
}: {
    item: ResultItemDetailValue;
    resultItemOnClickAction: (primaryText: string) => void;
}) {
    const onClickAction = () => resultItemOnClickAction(item.primaryText);
    return (
        <div
            className={classNames(
                sonoraCommonStyles.hoverable,
                sonoraCommonStyles.suggestionButtonContainer,
                sonoraCommonStyles.suggestionDetailsMenuContainer
            )}
            onClick={onClickAction}
            data-is-focusable={true}>
            <div className={sonoraCommonStyles.suggestionButtonIconContainer}>
                {getIconForSonoraResultsDetailsItems(item.icon)}
            </div>
            <div className={sonoraCommonStyles.suggestionButtonTextContainer}>
                <div className={sonoraCommonStyles.suggestionButtonPrimaryText}>
                    {item.primaryText}
                </div>
                {item.secondaryText !== '' && (
                    <div className={sonoraCommonStyles.suggestionButtonSecondaryText}>
                        {item.secondaryText}
                    </div>
                )}
            </div>
        </div>
    );
});
